module.exports = __webpack_public_path__ + "img/zhifubao.fb881738.png";